// Where the API lives. Development defaults to the local API; a production
// build MUST be given VITE_API_ORIGIN explicitly — no hostname is invented
// here (hosting/DNS are decided in 7.7).
const configured = (import.meta.env.VITE_API_ORIGIN as string | undefined)?.replace(/\/$/, "");

export const API_ORIGIN: string | null = configured ?? (import.meta.env.DEV ? "http://localhost:8787" : null);

export function apiUrl(path: string): string {
  if (API_ORIGIN === null) throw new Error("VITE_API_ORIGIN is not configured");
  return `${API_ORIGIN}${path}`;
}

/**
 * Automatic fallback images (Creative Studio 2.0). On by default; a deployment whose database does
 * not have migration 0022 yet builds with VITE_AUTO_FALLBACK=off (the manual upload stays available).
 */
export const AUTO_FALLBACK = (import.meta.env.VITE_AUTO_FALLBACK as string | undefined) !== "off";
